<template>
  <div>
    <template v-if="data !== null">
      <v-snackbar
        v-model="display"
        :color="data.type"
        :timeout="timeout"
        bottom
        right
      >
        <v-icon
          class="mr-3"
        >
          {{ data.icon }}
        </v-icon>
        <template v-if="typeof data.message === 'string'">
          {{ data.message }}
        </template>
        <template v-else>
          {{ $t("error." + get_eid(data.message.eid), replace_param(data.message.eid, data.message.param)) }}&nbsp;({{ data.message.eid }})
        </template>
        <v-spacer></v-spacer>
        <v-icon
          size="16"
          @click="clearSnackbar()"
        >
          mdi-close-circle
        </v-icon>
      </v-snackbar>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { get_eid } from "../js/get_eid";

export default {
  name: 'snackbar',
  mixins: [get_eid],
  data: function(){
    return {
      module_id: "55",
      display: false,
      data: null,
      timeout: 5000,
      timeoutId: null
    }
  },
  mounted: function() {
    this.displaySnackbar();
  },
  computed: {
    ...mapGetters([
      'snackbar'
    ])
  },
  methods: {
    displaySnackbar: function(){
      if (this.snackbar.length > 0 && this.data === null) {
        var data = this.snackbar.shift();
        switch(data.type){
          case "error":
            data.icon = "mdi-alert";
            break;
          case "warning":
            data.icon = "mdi-exclamation";
            break;
          case "success":
            data.icon = "mdi-check-circle";
            break;
          default:  // include "info"
            data.icon = "mdi-information";
            break;
        }
        this.data = data;
        this.display = true;
        this.timeoutId = setTimeout(() => {
          this.clearSnackbar();
        }, this.timeout + 50);
      }
    },
    clearSnackbar: function(){
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
      this.display = false;
      this.data = null;
      if (this.snackbar.length > 0) {
        this.displaySnackbar();
      }
    }
  },
  watch: {
    snackbar: function() {
      this.displaySnackbar();
    }
  }
}
</script>
